import axios from '../axios'
import {
    LEADERBOARD_REQUEST, LEADERBOARD_SUCCESS, LEADERBOARD_FAIL,
    LIVE_SCORES_REQUEST, LIVE_SCORES_SUCCESS, LIVE_SCORES_FAIL,
} from '../constants/leaderboardConstants'

export const getLeaderboard = () => async (dispatch) => {
    try {
        dispatch({ type: LEADERBOARD_REQUEST })
        const { data } = await axios.get('/api/leaderboard/')
        dispatch({ type: LEADERBOARD_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: LEADERBOARD_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const getLiveScores = () => async (dispatch) => {
    try {
        dispatch({ type: LIVE_SCORES_REQUEST })
        const { data } = await axios.get('/api/live/')
        dispatch({ type: LIVE_SCORES_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: LIVE_SCORES_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const updateTeamScore = (teamId, score) => async (dispatch, getState) => {
    const { userLogin: { userInfo } } = getState()
    const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
    }
    await axios.patch(`/api/live/teams/${teamId}/score/`, { score }, config)
    // Refresh live standings immediately after a successful score update
    dispatch(getLiveScores())
}

